import { colors, deviceSize, useDeviceSize } from 'fitify-ui'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import Features from '@/components/blocks/Features/Features'
import Header from '@/components/blocks/Header/Header'
import { MobileAnimation } from '@/components/blocks/MobileAnimation'
import { MobileAppFeatures } from '@/components/blocks/MobileAppFeatures'
import Reviews from '@/components/blocks/Reviews/Reviews'
import { Layout } from '@/components/layouts/Layout'
import { animationData } from '@/data/animations'
import { businessFeaturesData } from '@/data/features'
import { headerImages } from '@/data/header'
import { reviewsData } from '@/data/reviews'
import { getLocalizedImagePathConverter } from '@/utils/getLocalizedImagePathConverter'
import { getStaticPropsTranslations } from '@/utils/i18n'

const Home: NextPage = () => {
  const { i18n, t } = useTranslation()
  const headerLocalizedImages = useMemo(() => {
    const mainImage = getLocalizedImagePathConverter(
      {
        imageSrc: headerImages.mainImage.headerImage,
        imageSrcSet: headerImages.mainImage.headerImageSet,
      },
      i18n.language
    )
    return [
      {
        headerImage: mainImage.src,
        headerImageSet: mainImage.srcSet,
      },
      ...headerImages.slideshowImages,
    ]
  }, [i18n.language])

  const { windowWidth } = useDeviceSize()
  const isPhoneBreakpoint = windowWidth <= deviceSize.phone
  return (
    <Layout
      seo={{
        title: t('cl_landing_meta_title'),
        description: t('cl_landing_meta_description'),
      }}
      newsletterBackgroundColor={colors.RoyalBlue100}
    >
      <Header
        headerImages={headerLocalizedImages}
        headline={'cl_landing_page_title'}
        subheadline={'cl_landing_page_subtitle'}
      />
      {isPhoneBreakpoint ? (
        <MobileAppFeatures features={animationData} shouldUsePaddingForImage />
      ) : (
        <MobileAnimation features={animationData} />
      )}
      <Reviews
        headline={t('cl_landing_join_community_title')}
        items={reviewsData}
      />
      <Features items={businessFeaturesData} />
    </Layout>
  )
}

export default Home

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
